import { useEffect, useState } from "react";
import { getConsent, setConsent } from "../lib/analytics";
import { Button } from "./ui/button";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-card p-4 shadow-lg"
      data-testid="cookie-consent"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">
          We use privacy-conscious analytics to improve our calculators. No ads are running.
          You can accept or reject analytics — the calculators work either way.
        </p>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" size="sm" onClick={() => choose("rejected")} data-testid="consent-reject">
            Reject
          </Button>
          <Button size="sm" onClick={() => choose("accepted")} data-testid="consent-accept">
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};
